export default "__VITE_ASSET__Cj29xdJj__"